export default __webpack_public_path__ + "../sounds/alert.mp3";